import { useDevices, useLocations, useSchedule } from "@repo/data-store";
import { Skeleton } from "@repo/ui/components/ui/skeleton";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ScheduleSettings } from "@/features/scheduling";

export const Route = createFileRoute("/schedule/manage/$scheduleId")({
  beforeLoad: ({ context }) => {
    const { permissions } = context;

    if (!permissions.canRead("Schedule")) {
      throw redirect({ to: "/schedule", search: { view: "week" } });
    }
  },
  component: ScheduleDetailComponent,
});

function ScheduleDetailComponent() {
  const scheduleId = scheduleIdSchema.parse(Route.useParams().scheduleId);
  const { locations } = useLocations();
  const { devices } = useDevices();
  const { profile } = Route.useRouteContext();
  const { schedule, isLoading } = useSchedule(scheduleId);

  if (isLoading) {
    return (
      <div className="max-w-(--form-max-width) mx-auto p-4 space-y-4">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-64 w-full" />
      </div>
    );
  }

  if (!schedule) {
    return <div className="flex h-full items-center justify-center text-muted-foreground">Schedule not found</div>;
  }

  return (
    <ScheduleSettings
      allLocations={locations}
      allDevices={devices}
      mode="edit"
      scheduleId={scheduleId}
      profile={profile}
    />
  );
}

import { scheduleIdSchema } from "@repo/api/schemas";
